﻿import $ from 'jquery';
import '../../js/paceoptions.js';
import Pace from 'pace-js';

declare global {
  interface JQuery {
    loading(): JQuery;
    stopLoading(): JQuery;
  }
}

(function ($) {
  $.fn.loading = function () {
    let $element = $(this);
    let random = Math.random();
    $element.attr('data-loading-target', random)
    Pace.startOn('loading-target'.asDataSelector(random));
    return $(this);
  };
  $.fn.stopLoading = function () {
    Pace.stop();
    return $(this);
  };

  if (window.Pace) {
    Pace.startOn = function (selector) {
      var $target = $(selector).first();
      if ($target.length == 0)
        return;

      $target.addClass('pace-target-container');
      Pace.options.target = selector;
      Pace.restart();
    };

    Pace.on('hide', function () {
      $(Pace.options.target).removeClass('pace-target-container');
      Pace.options.target = window.paceOptions.target;
    });
  }
})($);

